export default "__VITE_ASSET__81a550a3__"